import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as actions from '../../actions'

class CompleteChanger extends Component {
  constructor (props) {
    super(props)

    this.state = {
      status: false,
      saving: false
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount () {
    this.setState({ status: this.props.complete })
  }

  onSubmit (ev) {
    ev.preventDefault()
    if (this.state.status === this.props.complete) {
      this.props.dispatch(actions.displayAlert('There is no change to save.'))
      return
    }
    this.props.dispatch(actions.changeTeamStatus({ id: this.props.id, status: this.state.status }))
    this.setState({ saving: true })
  }

  componentWillReceiveProps (nextProps) {
    nextProps.complete !== this.props.complete &&
      nextProps.close(nextProps.id)
  }

  render () {
    return (
      <div className='change-status-container'>
        {this.state.saving && <div className='saving-msg'>Saving...</div>}
        <div className='cell-subject changer-name'>
          <Link to={`/team/${this.props.id}`} target='_blank' className='color-inherit'>
            {this.props.name}
          </Link>
        </div>
        <form className='status-form' onSubmit={this.onSubmit}>
          <input
            type='radio'
            name='status'
            value='true'
            className='radio-bttn'
            checked={this.state.status}
            onChange={() => this.setState({ status: true })} />
          <span className='bttn-info' onClick={() => this.setState({ status: true })}>Yes</span>
          <input
            type='radio'
            name='status'
            value='false'
            className='radio-bttn'
            checked={!this.state.status}
            onChange={() => this.setState({ status: false })} />
          <span className='bttn-info' onClick={() => this.setState({ status: false })}>No</span>
          <input type='submit' value='✓' className='button button-sm save-bttn cursor-pointer' />
          <input type='button' value='✕' className='button button-sm cancel-bttn cursor-pointer' onClick={() => this.props.close(this.props.id)} />
        </form>
      </div>
    )
  }
}

export default connect()(CompleteChanger)



// WEBPACK FOOTER //
// ./src/screens/administration/CompleteChanger.js